import { useSuspenseQuery } from '@tanstack/react-query';

import {
  getPatentValidationOptions,
  useValidatePatent,
} from '@/module/Author/Patent/Validation/model/PatentValidationModel';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

interface ValidationActionProps {
  patentId: Id;
  variant?: ValidationVariant;
}

export function PatentValidationAction({ patentId, variant }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getPatentValidationOptions(patentId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidatePatent(patentId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
